import React from 'react';
import CommonModal from "../../../../share-components/ui/commonModal";
import {setActionDialog} from "../../store/prodcutSlice";
import {useDispatch} from "react-redux";
import SaleOffer from "./action/saleOffer";
import ProductTagsBulk from "./action/productTagsBulk";

const sharedProps = (props, closeDialog) => ({
    setSelectedPage: props.setSelectedPage,
    selectAllRef: props.selectAllRef,
    productFilter: props.productFilter,
    selectedProductId: props.selectedProductId,
    setSelectedProductId: props.setSelectedProductId,
    closeDialog,
    state: props.state,
});

function ProductAction(props) {
    const {state} = props;
    const dispatch = useDispatch();
    const closeDialog = () => {
        dispatch(setActionDialog({props: {isOpen: false}}));
    };

    const shared = sharedProps(props, closeDialog);

    return (
        <>
            <CommonModal closeDialog={closeDialog} modalProps={state.actionDialogProps}>
                {state.actionDialogProps.type === 2
                    ? <ProductTagsBulk {...shared}/>
                    : <SaleOffer {...shared}/>
                }
            </CommonModal>
        </>
    );
}

export default ProductAction;